<template>
  <section>
    <div class="row">
      <div class="col-md-3"></div>
      <!-- Search -->
      <div class="col-md-3">
        <z-search
          class="mt-2"
          name="search"
          label=""
          placeholder="Search"
          v-model="searchTerm"
          @search="onSearch"
        />
      </div>
      <!-- Action Buttons -->
      <div class="col-md-2">
        <div class="row mt-2">
          <div v-if="!isThere">
            <button class="btn btn-primary" @click="addHabit">Add</button>
          </div>
        </div>
      </div>
      <!-- Pagination -->
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-1">
            <z-select
              v-model="pageSize"
              :options="pageSizes"
              @change="changePageSize"
            />
          </div>
          <div class="col-md-6">
            <nav>
              <z-paginate
                v-model="page"
                :page-count="pages"
                @change="changePage"
              />
            </nav>
          </div>
          <div class="col-md-3"></div>
          <div class="col-md-2 custom-items">
            <h5 class="mt-2 mr-2" title="# items">{{ numItems }}</h5>
            <span class="custom-items-label">items</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ZSearch from '../ZElements/Search'
import ZSelect from '../ZElements/Select'
import ZPaginate from '../ZElements/Paginate'
export default {
  name: 'habits-header',
  components: {
    ZSearch,
    ZSelect,
    ZPaginate,
  },
  props: {
    pageSizes: {
      type: Array,
      default: [
        { name: '10', value: 10 },
        { name: '25', value: 25 },
        { name: '50', value: 50 },
        { name: '100', value: 100 },
      ],
    },
    isThere: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newName: null,
      isEdit: false,
    }
  },
  emits: ['search', 'add', 'delete'],
  computed: {
    ...mapGetters('nutrition', ['pager']),
    ...mapGetters('usercardio', ['summary']),
    numItems() {
      let _items = 0
      if (this.pager) {
        _items = this.pager.total
      }
      return _items
    },
    pages() {
      let _pages = 1
      if (this.pager) {
        _pages = this.pager.pages ? this.pager.pages : 1
      }
      return _pages
    },
    pageSize: {
      get() {
        let _pageSize = 10
        if (this.pager) {
          _pageSize = this.pager.pageSize ? this.pager.pageSize : 10
        }
        return _pageSize
      },
      set(value) {
        this.page = 1
        this.setPager({
          name: 'pageSize',
          value: value,
        })
        this.setPager({
          name: 'page',
          value: 1,
        })
        this.setPager({
          name: 'search',
          value: '',
        })
      },
    },
    page: {
      get() {
        let _page = 1
        if (this.pager) {
          _page = this.pager.page ? this.pager.page : 1
        }
        return _page
      },
      set(value) {
        this.setPager({
          name: 'page',
          value: value,
        })
      },
    },
    searchTerm: {
      get() {
        let _search = null
        if (this.pager) {
          _search = this.pager.search
        }
        return _search
      },
      set(value) {
        this.setPager({
          name: 'search',
          value: value,
        })
      },
    },
  },
  methods: {
    ...mapActions('nutrition', ['setPager']),
    changePage() {
      this.$emit('search')
    },
    changePageSize() {
      this.$emit('search')
    },
    onSearch() {
      if (this.page > 1) {
        this.page = 1
      }
      this.$emit('search')
    },
    addHabit() {
      this.$emit('add')
    },
    deleteHabit() {
      this.$emit('delete')
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-items {
  text-align: right;
}
.custom-items-label {
  right: 10px;
  top: -10px;
  position: relative;
}
.custom-habit {
  position: relative;
  span {
    font-size: 1.1em;
    font-weight: 500;
  }
  button {
    position: relative;
    top: -4px;
  }
}
.custom-habit-edit {
  position: relative;
  display: inline-flex;
  input {
    width: 200px;
  }
  i {
    font-size: 1.3em;
  }
}
</style>
